import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/customerservice');

export const customerApiPaths = {
  customersList: withRoot('/customers'),
  customersInvite: withRoot('/customers/invite'),
  customerById: withRoot('/customers/:customerId'),
  customerByUserId: withRoot('/customers/userid/:userId'),
} as const;

export const getCustomerApiUrl = {
  customersList: () => customerApiPaths.customersList,
  customersInvite: () => customerApiPaths.customersInvite,
  customerById: (customerId: string) => replacePathParams(customerApiPaths.customerById, { customerId }),
  customerByUserId: (userId: string) => replacePathParams(customerApiPaths.customerByUserId, { userId }),
};
